<template>
  <div class="container mt-5">
    <div class="row mt-3">
      <div class="col-md-3">
        <ul>
          <router-link
            to="/admin/"
            tag="li"
            class="pa-4 mb-1"
          >
            Stocks List
          </router-link>
          <router-link
            to="/admin/userlist"
            tag="li"
            class="pa-4 mb-1"
          >
            User List
          </router-link>
          <router-link
            to="/admin/addnewstock"
            tag="li"
            class="pa-4 mb-1"
          >
            Add New Stock
          </router-link>
          <router-link
            to="/admin/addnewuser"
            tag="li"
            class="pa-4 mb-1"
          >
            Add New User
          </router-link>
        </ul>
      </div>
      <div class="col-md-9">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: "Admin",
    computed: {
      ...mapGetters(["user"])
    },
    mounted() {
      if (!this.user) {
        this.$router.push("/login");
        return;
      }
      if (this.user.admin != 999) {
        this.$router.push("/myaccount");
        return;
      }
    }
  };
</script>

<style lang="scss" scoped>
  ul {
    list-style: none;
    li {
      color: white;
      background-color: #31cc9a;
      text-align: center;
      font-weight: 600;
      cursor: pointer;
    }
  }
  .bg1 {
    background-color: #fff;
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
  }
</style>



// WEBPACK FOOTER //
// src/views/Admin.vue